import React, { useState, useEffect } from 'react';
import styles from './Checkout.module.css';
import { useCart } from '../../context/CartContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../../services/api';
import SEO from '../../components/common/SEO';

const Checkout = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { cartItems } = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  const directProduct = location.state?.directProduct;

  // Si es compra directa, no agregar al carrito, solo procesar el producto recibido
  const productsToBuy = React.useMemo(() => directProduct ? [directProduct] : cartItems, [directProduct, cartItems]);

  useEffect(() => {
    console.log('Producto recibido en Checkout:', directProduct);
    console.log('Productos a comprar:', productsToBuy);
    if (directProduct === undefined && cartItems.length === 0) {
      alert('No se recibió ningún producto para comprar. Regresa y selecciona un producto.');
    }
  }, [directProduct, cartItems, productsToBuy]);

  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  });

  useEffect(() => {
    const guestEmail = localStorage.getItem('guest_email');
    if (guestEmail) setForm(f => ({ ...f, email: guestEmail }));
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const total = productsToBuy.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0);

  const handleSubmit = async e => {
    e.preventDefault();
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'El nombre es obligatorio.';
    if (!form.phone.trim() || !/^\d{7,15}$/.test(form.phone.trim())) newErrors.phone = 'Teléfono inválido.';
    if (!form.address.trim()) newErrors.address = 'La dirección es obligatoria.';
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;
    setLoading(true);
    try {
      const data = await apiService.createOrder({
        ...form,
        products: productsToBuy
      });
      if (data.paymentUrl) {
        window.location.href = data.paymentUrl;
      } else if (data.urlEnlace) {
        window.location.href = data.urlEnlace;
      } else if (data.urlEnlaceLargo) {
        window.location.href = data.urlEnlaceLargo;
      } else {
        alert('No se recibió la URL de pago.');
      }
    } catch (err) {
      alert('Error al procesar la orden');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.checkoutContainer}>
      <SEO 
        title="Checkout - Nexa Global"
        description="Finaliza tu compra"
        noindex={true}
      />
      {/* Header personalizado */}
      <div className={styles.customHeader}>
        <img src="/Nexa-Globals-Hlogo-removebg-preview.png" alt="Logo" className={styles.logo} />

        <button className={styles.backButton} onClick={() => navigate(-1)}>
          ← Atrás
        </button>
      </div>
      <div className={styles.checkoutGrid}>
        {/* Columna izquierda */}
        <div className={styles.leftColumn}>
          <div className={styles.formSection}>
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.row}>
                <label>
                  Nombre:
                  <input name="name" value={form.name} onChange={handleChange} required />
                  {errors.name && <span className={styles.error}>{errors.name}</span>}
                </label>
                <label>
                  Teléfono:
                  <input name="phone" value={form.phone} onChange={handleChange} required />
                  {errors.phone && <span className={styles.error}>{errors.phone}</span>}
                </label>
              </div>
              <div className={styles.row}>
                <label>
                  Dirección:
                  <input name="address" value={form.address} onChange={handleChange} required />
                  {errors.address && <span className={styles.error}>{errors.address}</span>}
                </label>
                <label>
                  Correo electrónico:
                  <input name="email" value={form.email} onChange={handleChange} required />
                </label>
              </div>
            </form>
          </div>
          <div className={styles.productsSection}>
            <h3>Productos</h3>
            <div className={styles.productsList}>
              {productsToBuy.map(item => (
                <div key={item.id} className={styles.productItem}>
                  <img
                    src={
                      // Si tiene product_images, busca la principal
                      Array.isArray(item.product_images)
                        ? (item.product_images.find(img => img.is_primary)?.cloudflare_url || item.product_images[0]?.cloudflare_url || '/placeholder-image.jpg')
                        : (item.primary_image || item.image || '/placeholder-image.jpg')
                    }
                    alt={item.name}
                    className={styles.productImage}
                  />
                  <div className={styles.productInfo}>
                    <div className={styles.productName}>{item.name}</div>
                    <div className={styles.productQty}>Cantidad: {item.quantity || 1}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Columna derecha */}
        <div className={styles.rightColumn}>
          <div className={styles.summaryBox}>
            <h3>Resumen</h3>
            <div className={styles.summaryRow}>
              <span>Subtotal:</span>
              <span>${total.toFixed(2)}</span>
            </div>
            <div className={styles.summaryRow}>
              <span>Envío:</span>
              <span>$0.00</span>
            </div>
            <div className={styles.summaryRowTotal}>
              <span>Total:</span>
              <span>${total.toFixed(2)}</span>
            </div>
            <button
              type="button"
              className={styles.payButton}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Procesando...' : 'Pagar con Wompi'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;